'use client';

export { default } from './Pagination';
export { default as paginationClasses } from './paginationClasses';
export * from './paginationClasses';


//////////////////
// WEBPACK FOOTER
// ../@mui/material/Pagination/index.js
// module id = 867
// module chunks = 22